import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { GuestGuard } from 'src/auth/guard';
// layouts
import AuthClassicLayout from 'src/layouts/auth/classic';
import CompactLayout from 'src/layouts/compact';
// components
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// FIREBASE
const FirebaseLoginPage = lazy(() => import('src/pages/auth/firebase/login'));
const FirebaseRegisterPage = lazy(() => import('src/pages/auth/firebase/register'));
const FirebaseVerifyPage = lazy(() => import('src/pages/auth/firebase/verify'));
const FirebaseForgotPasswordPage = lazy(() => import('src/pages/auth/firebase/forgot-password'));

// MFA
const VerifyUserCodePage = lazy(() => import('src/pages/auth/firebase/multifactor-authentication/verify-user-code'));
const VerifyUserOtpCodePage = lazy(() => import('src/pages/auth/firebase/multifactor-authentication/verify-user-totp-code'));
const SelectSecondVerificationPage = lazy(() => import('src/pages/auth/firebase/multifactor-authentication/select-second-verification'));
const SecondFactorRecoveryPage = lazy(() => import('src/pages/auth/firebase/multifactor-authentication/second-factor-recovery'));
const CheckSecondFactorRecoveryPage = lazy(() => import('src/pages/auth/firebase/multifactor-authentication/check-second-factor-recovery'));

// CONSENT
const ManageConsentPage = lazy(() => import('src/pages/auth/consent/manage-consent'));

// ----------------------------------------------------------------------

const authFirebase = {
  path: 'firebase',
  element: (
    <GuestGuard>
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    </GuestGuard>
  ),
  children: [
    {
      element: (
        <AuthClassicLayout>
          <Outlet />
        </AuthClassicLayout>
      ),
      children: [
        { path: 'login', element: <FirebaseLoginPage /> },
        {
          path: 'mfa',
          children: [
            { path: 'verify-user-code', element: <VerifyUserCodePage /> },
            { path: 'verify-user-otp-code', element: <VerifyUserOtpCodePage /> },
            { path: 'select-second-verification', element: <SelectSecondVerificationPage /> },
          ],
        },
        {
          path: 'consent',
          children: [
            { path: 'manage-consent', element: <ManageConsentPage /> },
          ],
        },
      ],
    },
    {
      path: 'register',
      element: (
        <AuthClassicLayout title="Manage your translations more effectively with Simple Translate">
          <FirebaseRegisterPage />
        </AuthClassicLayout>
      ),
    },
    {
      element: (
        <CompactLayout>
          <Outlet />
        </CompactLayout>
      ),
      children: [
        { path: 'verify', element: <FirebaseVerifyPage /> },
        { path: 'forgot-password', element: <FirebaseForgotPasswordPage /> },
        {
          path: 'mfa',
          children: [
            { path: 'second-factor-recovery', element: <SecondFactorRecoveryPage /> },
            { path: 'check-second-factor-recovery', element: <CheckSecondFactorRecoveryPage /> },
          ],
        },
      ],
    },
  ],
};

export const authRoutes = [
  {
    path: 'auth',
    children: [authFirebase],
  },
];
